import React from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import ButtonItem from './ButtonItem'


export interface NavItemsProps {
  open?: boolean
}

export interface NavItemProps {
  uri: string
  title: string
  icon: string | React.ReactNode
  base?: string
  nested?: boolean
  notification?: React.ReactNode
  notificationColor?: any
  openItem?: boolean
  subItem?: boolean
  onClick?: () => void
}

const NavItem: React.FC<NavItemProps & NavItemsProps> = (props) => {
  const { uri, title, base } = props
  const history = useHistory()
  const location = useLocation()
  const path = `/${base}/${uri}`

  return (
    <ButtonItem 
      selected={location.pathname === path}
      onClick={props.onClick ? props.onClick : () => history.push(path, { title })}
      {...props} />
  )
}

export default NavItem